import { $$ } from '@starberry/components';

const SectionHeading = {
  $: 'Flex',
  props: {},
  children: ({ title, textProps }) => [
    {
      $: 'Heading',
      children: title,
      props: {
        fontSize: ['12px', null, '22px'],
        lineHeight: ['20px', null, '26px'],
        fontWeight: 'bold',
        color: $$('constants.colors.grey6', null, 'constants.headings.baseHeading.color'),
        ...textProps,
      },
    },
  ],
};

export default SectionHeading;
